export default __webpack_public_path__ + "static/media/Cart1.bf7ddd76.svg";